'use strict';

/**
 * Create a Google map in element
 *
 * @param {jQuery object} element The jQuery element
 */
var mapsCenters = [];
var map;
var googleMarkers = [];
var infowindow = null;

window.createGoogleMap = function createGoogleMap( mapSettings, markers ) {
	if ( !mapSettings.element.length ) {
		return;
	}

	var latitude = R.map.latitude;
	if ( mapSettings.latitude ) {
		latitude = mapSettings.latitude;
	}

	var longitude = R.map.longitude;
	if ( mapSettings.latitude ) {
		longitude = mapSettings.longitude;
	}

	var zoom = R.map.zoom;
	if ( mapSettings.zoom ) {
		zoom = mapSettings.zoom;
	}

	var scrollwheel = false;
	if ( mapSettings.scrollwheel ) {
		scrollwheel = mapSettings.scrollwheel;
	}

	var styles = [
		{
			"featureType": "administrative",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#303d36"
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "all",
			"stylers": [
				{
					"color": "#f2f2f2"
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "all",
			"stylers": [
				{
					"saturation": -100
				},
				{
					"lightness": 45
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "simplified"
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "labels.icon",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "transit",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "all",
			"stylers": [
				{
					"color": "#3277AC"
				},
				{
					"visibility": "on"
				}
			]
		}
	];

	if ( mapSettings.monochrome ) {
		styles = [
			{
				"stylers": [
					{ "saturation": -100 }
				]
			}
		];
	}

	var mapLocation = new google.maps.LatLng( latitude, longitude );
	var mapOptions = {
		zoom: zoom,
		center: mapLocation,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		draggable: true,
		scrollwheel: scrollwheel,
		disableDoubleClickZoom: false
	};

	var styledMap = new google.maps.StyledMapType( styles, { name: "Styled Map" } );
	map = new google.maps.Map( mapSettings.element[ 0 ], mapOptions );
	map.mapTypes.set( 'map_style', styledMap );
	map.setMapTypeId( 'map_style' );
	var latLonBounds = new google.maps.LatLngBounds();

	infowindow = new google.maps.InfoWindow( {
		content: '...',
		maxWidth: 250
	} );

	if ( markers ) {
		for ( var markerIndex = 0; markerIndex < markers.length; markerIndex++ ) {
			var markerPosition = new google.maps.LatLng( markers[ markerIndex ].latitude, markers[ markerIndex ].longitude );

			latLonBounds.extend( markerPosition );

			var markerTitle = R.map.title;
			if ( markers[ markerIndex ].title ) {
				markerTitle = markers[ markerIndex ].title;
			}

			var markerImage = new google.maps.MarkerImage( R.map.marker,
				new google.maps.Size( 48, 48 ),
				new google.maps.Point( 0, 0 ),
				new google.maps.Point( 24, 24 ) );
			if ( markers[ markerIndex ].markerImage ) {
				markerImage = new google.maps.MarkerImage( markers[ markerIndex ].markerImage,
					new google.maps.Size( parseInt( markers[ markerIndex ].markerWidth ), parseInt( markers[ markerIndex ].markerHeight ) ),
					new google.maps.Point( 0, 0 ),
					new google.maps.Point( parseInt( markers[ markerIndex ].markerWidth ) / 2, parseInt( markers[ markerIndex ].markerHeight ) / 2 ) );
				;
			}

			var infowWindowContent;
			if ( mapSettings.infoWindows ) {
				var infowWindowContent = '<div class="info-window">';
				if ( markers[ markerIndex ].permalink ) {
					infowWindowContent += '<a href="' + markers[ markerIndex ].permalink + '">';
				}
				if ( markers[ markerIndex ].image ) {
					infowWindowContent += '<img src="' + markers[ markerIndex ].image + '" alt="' + markers[ markerIndex ].title + '">';
				}
				if ( markers[ markerIndex ].title ) {
					infowWindowContent += '<h2>' + markers[ markerIndex ].title + '</h2>';
				}
				if ( markers[ markerIndex ].subtitle ) {
					infowWindowContent += '<h3>' + markers[ markerIndex ].subtitle + '</h3>';
				}
				if ( markers[ markerIndex ].content ) {
					infowWindowContent += markers[ markerIndex ].content;
				}
				if ( markers[ markerIndex ].permalink ) {
					infowWindowContent += '</a>';
				}
				infowWindowContent += '</div>';
			}

			var marker = new google.maps.Marker( {
				title: markerTitle,
				position: markerPosition,
				zIndex: 1,
				html: infowWindowContent,
				map: map,
				id: markers[ markerIndex ].id,
				icon: markerImage
			} );

			if ( infowWindowContent ) {
				google.maps.event.addListener( marker, 'click', function() {
					infowindow.setContent( this.html );
					infowindow.open( map, this );
				} );
			}

			googleMarkers.push( marker );
		}
	}

	if ( markers.length > 1 ) {
		map.fitBounds( latLonBounds );
	} else if ( markers.length ) {
		map.setCenter( new google.maps.LatLng( markers[ 0 ].latitude, markers[ 0 ].longitude ) );
	}

	// Center the map when resizing the window
	google.maps.event.addDomListener( window, 'resize', function() {
		map.setCenter( mapLocation );
		if ( markers.length > 1 ) {
			map.fitBounds( latLonBounds );
		} else if ( markers.length ) {
			map.setCenter( new google.maps.LatLng( markers[ 0 ].latitude, markers[ 0 ].longitude ) );
		}
	} );
}

function showStreetview( element, streetviewSettings ) {
	var povPitch = 50;
	if ( streetviewSettings.pitch ) {
		povPitch = streetviewSettings.pitch;
	}

	var povHeading = 120;
	if ( streetviewSettings.heading ) {
		povHeading = streetviewSettings.heading;
	}

	var panoramaOptions = {
		position: new google.maps.LatLng( streetviewSettings.latitude, streetviewSettings.longitude ),
		draggable: false,
		scrollwheel: false,
		pov: {
			heading: povHeading,
			pitch: povPitch
		}
	};
	var panorama = new google.maps.StreetViewPanorama( element[ 0 ], panoramaOptions );
}

export function updateGoogleMapMarkers( ids ) {
	var latLonBounds = new google.maps.LatLngBounds();
	var visibleMarkerCounter = 0;

	for ( var markerIndex = 0; markerIndex < googleMarkers.length; markerIndex++ ) {
		if ( ids === 42 || ids.indexOf( googleMarkers[ markerIndex ].id ) > -1 ) {
			visibleMarkerCounter++;
			googleMarkers[ markerIndex ].setVisible( true );
			latLonBounds.extend( googleMarkers[ markerIndex ].position );
		} else {
			googleMarkers[ markerIndex ].setVisible( false );
		}
	}

	if ( visibleMarkerCounter > 1 ) {
		map.fitBounds( latLonBounds );
	}
}
